import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { trackByIndex } from '@blaze-shared/shared-util';

@Component({
  selector: 'blaze-mobile-pagination',
  templateUrl: './mobile-pagination.component.html',
  styleUrls: ['./mobile-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MobilePaginationComponent implements OnChanges {
  @Input() itemsCount = 0;
  @Input() maxItemsCount = 5;
  @Input() selectedIndex = 0;
  @Input() itemWidthPx = 15;
  @Input() color = '#bbb';
  @Input() selectedColor = '#000';

  items: any[] = [];
  translateLeftPx = 0;
  containerWidthPx = this.itemWidthPx * this.maxItemsCount;

  readonly trackByIndex = trackByIndex;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemsCount']) {
      this.items = new Array(this.itemsCount).fill(null);
    }

    if (changes['selectedIndex'] || changes['itemsCount'] || changes['maxItemsCount']) {
      this.updatePaginationPosition();
    }

    if (changes['itemWidthPx'] || changes['maxItemsCount']) {
      this.containerWidthPx = this.itemWidthPx * this.maxItemsCount;
    }
  }

  private updatePaginationPosition(): void {
    const middleIndex = Math.max(0, Math.ceil(this.maxItemsCount / 2) - 1);
    if (this.selectedIndex <= middleIndex) {
      this.translateLeftPx = 0;
      return;
    }

    if (this.selectedIndex >= this.itemsCount - middleIndex) {
      this.translateLeftPx = -1 * (this.itemsCount - this.maxItemsCount) * this.itemWidthPx;
      return;
    }

    this.translateLeftPx = -1 * (this.selectedIndex - middleIndex) * this.itemWidthPx;
  }
}
